import {
  isRefundAttemptStatus,
  mapRefundCustomerStatus as mapSharedRefundCustomerStatus,
  type RefundCustomerFacingReadDTO,
  type RefundCustomerStatus,
} from 'pi-kiosk-shared';
import { isRefundRequestedQueueReadDTO } from './refundReadTypes.js';

export { mapRefundCustomerStatus } from 'pi-kiosk-shared';

/**
 * Clamp a customer/guest refund row to the shared mapper.
 * REQUESTED queue placeholders (`RefundRequestedQueueReadDTO`) never map to returned.
 */
export function clampRefundCustomerStatus(
  input: RefundCustomerFacingReadDTO,
): RefundCustomerStatus {
  if (isRefundRequestedQueueReadDTO(input)) {
    return mapSharedRefundCustomerStatus({
      attemptStatus: null,
      slaBreachedAt: input.slaBreachedAt,
      saleRefundStatus: 'REQUESTED',
    });
  }
  const attemptStatus = isRefundAttemptStatus(input.attemptStatus)
    ? input.attemptStatus
    : null;
  return mapSharedRefundCustomerStatus({
    attemptStatus,
    slaBreachedAt: input.slaBreachedAt,
  });
}
